import { FC, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import store from "../../../store/store";
import { addBreadcrumb } from "../../../components/Breadcrumbs/reducer/breadcrumbSlice";
import AddBrand from "../AddAdmin";

const InitMiddlewareAddBrand:React.FC<any> = (props) => {
  const { signUpResponse = {}, isSuccess } = useSelector(
    (state: any) => state.rootReducer?.auth ?? {}
  );
  const navigate = useNavigate();

  useEffect(() => {
    const data: any = [
      {
        label: "admins",
        link: `/admins`,
      },
      {
        label: "Add new admin",
        link: ``,
      },
    ];
    store.dispatch(addBreadcrumb(data));
  }, []);
  
  console.log("signUpResponse", signUpResponse, isSuccess);
  useEffect(() => {
    if (isSuccess && signUpResponse?.success === true) {
      navigate("/admins");
    }
  }, [isSuccess, signUpResponse, navigate]);

  // if (isSuccess && addOfferRes?.data?.success === true) {
  //   navigate("/offers")
  //   return null;
  // } else {
  //   return <AddBrand {...props} />;
  // }
  return <AddBrand {...props} />;
};

export default InitMiddlewareAddBrand;
